<div class="content" [innerHTML]="contentTemplate"></div>
